export default __webpack_public_path__ + "static/media/culture_and_tradition.c9dfb168.svg";